import { ResolveFn } from '@angular/router';
import {inject} from '@angular/core';
import {HeaderService} from '../header.service';

export const headerResolver: ResolveFn<boolean> = (route) => {
  if (route.data['title']) {
    inject(HeaderService).setTitle(route.data['title']);
    return true;
  }
  if (route.data['headerVariant']) {
    inject(HeaderService).setVariant(route.data['headerVariant']);
  }
  return true;
};
